@if (renderIcon$ | async) {
  <div class="icon" [glxyPopover]="popover" (mousedown)="popover.open()">
    <div class="icon-display-container">
      <mat-icon class="icon-display">sync_alt</mat-icon>
    </div>
  </div>
}
<glxy-popover #popover [(isOpen)]="popoverShown" [closeOnBackdropClick]="true">
  <glxy-popover-title>{{ 'SYNC.TITLE' | translate }}</glxy-popover-title>
  {{ 'SYNC.DESCRIPTION' | translate }}
  <a class="blue-text" (click)="openAccount()">{{ 'SYNC.ACCOUNT' | translate }}</a>
</glxy-popover>
